import React from 'react';
import { useMetaMenuLinks } from './hooks/use-meta-menu-links';
import { MetaMenuLink } from './components/meta-menu-link';
import styles from './nav-bar-meta-menu.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavBarMetaMenu = function NavBarMetaMenu() {
  var metaMenuLinks = useMetaMenuLinks();

  if (!metaMenuLinks.userLinks.length) {
    return null;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: "align-self-center d-flex gap-200",
    children: [/*#__PURE__*/_jsx("div", {
      className: "align-self-center d-none d-md-block",
      children: /*#__PURE__*/_jsx(MetaMenuLink, {
        className: styles.metaMenuLink,
        link: metaMenuLinks.contactSalesLink,
        variant: "link"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "align-self-center gap-100 d-none d-sm-flex",
      children: metaMenuLinks.userLinks.map(function (_ref) {
        var variant = _ref.variant,
            link = _ref.link;
        return /*#__PURE__*/_jsx(MetaMenuLink, {
          className: styles.metaMenuLink,
          link: link,
          variant: variant
        }, link === null || link === void 0 ? void 0 : link.path);
      })
    })]
  });
};